// extracted by mini-css-extract-plugin
export default {"root":"Tag_root__j5hW3"};